var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "div",
        { staticClass: "title-row" },
        [
          _c("div", [
            _c(
              "div",
              { staticStyle: { "font-size": "20px", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.$t("home.publishSystemMessage")))]
            ),
            _c("p", [_vm._v(_vm._s(_vm.$t("home.publishSystemMessageDesc")))]),
          ]),
          _c("el-button", { on: { click: _vm.handleBackList } }, [
            _vm._v(_vm._s(_vm.$t("home.backToMessageList"))),
          ]),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            disabled: _vm.viewMode === "view",
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "auto",
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "panel", attrs: { shadow: "never" } },
            [
              _c("template", { slot: "header" }, [
                _c("h2", { staticClass: "panel-title" }, [
                  _vm._v(_vm._s(_vm.$t("home.basicInfoSection"))),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.messageType"),
                            prop: "msgType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.form.msgType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "msgType", $$v)
                                },
                                expression: "form.msgType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.urgentAnnouncement"),
                                  value: "URGENT_NOTICE",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.operationNotice"),
                                  value: "OPERATIONAL_NOTICE",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.systemUpdate"),
                                  value: "GXTS",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.normalNotice"),
                                  value: "TZ",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.titleChinese"),
                            prop: "zhTitle",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 100,
                              placeholder: _vm.$t("home.pleaseInput"),
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.zhTitle,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "zhTitle", $$v)
                              },
                              expression: "form.zhTitle",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.titlePortuguese"),
                            prop: "title",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 100,
                              placeholder: _vm.$t("home.pleaseInput"),
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("home.abstractChinese") } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 200,
                              placeholder: _vm.$t("home.pleaseInput"),
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.zhAbstract,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "zhAbstract", $$v)
                              },
                              expression: "form.zhAbstract",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("home.abstractPortuguese") } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 200,
                              placeholder: _vm.$t("home.pleaseInput"),
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.puAbstract,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "puAbstract", $$v)
                              },
                              expression: "form.puAbstract",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("home.contentChinese") } },
                        [
                          _c("tinymce", {
                            attrs: {
                              height: 150,
                              "is-image": _vm.isImage,
                              "msg-plugin": _vm.msgPlugin,
                              placeholder:
                                _vm.$t("GlobalSetObj.pleaseInputContent") +
                                "...",
                              toolbar: _vm.toolbar,
                            },
                            model: {
                              value: _vm.form.zhText,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "zhText", $$v)
                              },
                              expression: "form.zhText",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("home.contentPortuguese") } },
                        [
                          _c("tinymce", {
                            attrs: {
                              height: 150,
                              "is-image": _vm.isImage,
                              "msg-plugin": _vm.msgPlugin,
                              placeholder:
                                _vm.$t("GlobalSetObj.pleaseInputContent") +
                                "...",
                              toolbar: _vm.toolbar,
                            },
                            model: {
                              value: _vm.form.puText,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "puText", $$v)
                              },
                              expression: "form.puText",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("home.image") } },
                        [
                          _c("div", { staticClass: "upload-area" }, [
                            _c("div", { staticClass: "upload-info" }, [
                              _c("div", { staticClass: "upload-icon" }, [
                                _vm._v("🖼️"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "upload-text" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.uploadMessageImage"))
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.uploadImageDesc"))
                                    ),
                                  ]),
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-btn",
                                      attrs: {
                                        accept: _vm.acceptType,
                                        action: _vm.uploadAction,
                                        "before-upload": _vm.beforeUpload,
                                        "http-request": _vm.customUpload,
                                        "show-file-list": false,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            loading: _vm.uploadLoading,
                                            size: "small",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.imageUrl
                                                  ? _vm.$t("home.changeImage")
                                                  : _vm.$t("home.selectImage")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "upload-preview" },
                              [
                                _vm.imageUrl
                                  ? [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                        },
                                        attrs: {
                                          "preview-src-list": [_vm.imageUrl],
                                          src: _vm.imageUrl,
                                          fit: "cover",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "preview-close",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleRemoveImage(
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("✕")]
                                      ),
                                    ]
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("home.imagePreviewArea"))
                                      ),
                                    ]),
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-card",
            { staticClass: "panel", attrs: { shadow: "never" } },
            [
              _c("template", { slot: "header" }, [
                _c("h2", { staticClass: "panel-title" }, [
                  _vm._v(_vm._s(_vm.$t("home.notificationRulesSection"))),
                ]),
              ]),
              _c("el-alert", {
                staticStyle: { "margin-bottom": "18px" },
                attrs: {
                  closable: false,
                  title: _vm.$t("home.ruleDescription"),
                  "show-icon": "",
                  type: "info",
                },
              }),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.system"),
                            prop: "systemType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              on: { change: _vm.handleSystemTypeChange },
                              model: {
                                value: _vm.form.systemType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "systemType", $$v)
                                },
                                expression: "form.systemType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: _vm.$t("home.all"), value: 0 },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.expressSystem"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.providerSystem"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.displayPosition"),
                            prop: "displayLocat",
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.form.displayLocat,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "displayLocat", $$v)
                                },
                                expression: "form.displayLocat",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                { attrs: { label: 1, border: "" } },
                                [_vm._v(_vm._s(_vm.$t("home.loginPopup")))]
                              ),
                              _c(
                                "el-checkbox",
                                { attrs: { label: 2, border: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("home.importantReminderBanner")
                                    ) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                { attrs: { label: 3, border: "" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("home.announcementCard"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.displayLocat.length > 0
                ? _c(
                    "div",
                    { staticClass: "login-only-section" },
                    [
                      _vm.form.displayLocat.includes(1)
                        ? _c("div", { staticClass: "login-only-head" }, [
                            _vm._v(
                              " 🔐 " +
                                _vm._s(_vm.$t("home.loginPopupRule")) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.form.displayLocat.includes(1)
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("home.userEnd"),
                                        prop: "clientType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          model: {
                                            value: _vm.form.clientType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "clientType",
                                                $$v
                                              )
                                            },
                                            expression: "form.clientType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("home.all"),
                                              value: 0,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("home.pcEnd"),
                                              value: 1,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("home.appEnd"),
                                              value: 2,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("home.popupCloseMethod"),
                                        prop: "howToClose",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          model: {
                                            value: _vm.form.howToClose,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "howToClose",
                                                $$v
                                              )
                                            },
                                            expression: "form.howToClose",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label:
                                                _vm.$t("home.directlyClose"),
                                              value: 0,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "home.closeAfter10Seconds"
                                              ),
                                              value: 10,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "home.closeAfter20Seconds"
                                              ),
                                              value: 20,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "home.closeAfter30Seconds"
                                              ),
                                              value: 30,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "home.closeAfter60Seconds"
                                              ),
                                              value: 60,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("home.receiveUser"),
                                    prop: "receptType",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "range-box" },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "12px",
                                          },
                                          model: {
                                            value: _vm.form.receptType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "receptType",
                                                $$v
                                              )
                                            },
                                            expression: "form.receptType",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1, border: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("home.allUsers"))
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2, border: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("home.specifiedArea")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 3, border: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("home.specifiedState")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 4, border: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("home.specifiedSite")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm.form.systemType !== 0
                                            ? _c(
                                                "el-radio",
                                                {
                                                  attrs: {
                                                    label: 5,
                                                    border: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "home.specifiedUser"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "conditional-selects" },
                                        [
                                          _vm.form.receptType === 2
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key:
                                                    "regionId-" +
                                                    _vm.form.receptType,
                                                  attrs: {
                                                    rules: [
                                                      {
                                                        required: true,
                                                        message: _vm.$t(
                                                          "home.pleaseSelectArea"
                                                        ),
                                                        trigger: "change",
                                                      },
                                                    ],
                                                    prop: "regionId",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "320px",
                                                        "margin-right": "12px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          _vm.$t(
                                                            "home.selectArea"
                                                          ),
                                                        clearable: "",
                                                        filterable: "",
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.handleRegionChange,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.regionId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "regionId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.regionId",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.regionList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.id,
                                                          attrs: {
                                                            label:
                                                              item.zhName +
                                                              "（" +
                                                              item.puName +
                                                              "）",
                                                            value: item.id,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.form.receptType === 3
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key:
                                                    "siteStateList-" +
                                                    _vm.form.receptType,
                                                  attrs: {
                                                    rules: [
                                                      {
                                                        required: true,
                                                        message: _vm.$t(
                                                          "home.pleaseSelectState2"
                                                        ),
                                                        trigger: "change",
                                                      },
                                                    ],
                                                    prop: "siteStateList",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "320px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          _vm.$t(
                                                            "home.selectState"
                                                          ),
                                                        clearable: "",
                                                        "collapse-tags": "",
                                                        filterable: "",
                                                        multiple: "",
                                                      },
                                                      on: {
                                                        change: function (val) {
                                                          return _vm.handleAllChange(
                                                            "siteStateList",
                                                            val
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .siteStateList,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "siteStateList",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.siteStateList",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.stateData,
                                                      function (item, index) {
                                                        return _c("el-option", {
                                                          key: index,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.label,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.form.receptType === 4
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key:
                                                    "siteList-" +
                                                    _vm.form.receptType,
                                                  attrs: {
                                                    rules: [
                                                      {
                                                        required: true,
                                                        message: _vm.$t(
                                                          "home.pleaseSelectSite"
                                                        ),
                                                        trigger: "change",
                                                      },
                                                    ],
                                                    prop: "siteList",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "320px",
                                                        "margin-right": "12px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          _vm.$t(
                                                            "home.selectSite"
                                                          ),
                                                        clearable: "",
                                                        "collapse-tags": "",
                                                        filterable: "",
                                                        multiple: "",
                                                      },
                                                      on: {
                                                        change: function (val) {
                                                          return _vm.handleSelectChange(
                                                            "siteList",
                                                            val,
                                                            20
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.siteList,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "siteList",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.siteList",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.siteList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.id,
                                                          attrs: {
                                                            label: item.name,
                                                            value: item.id,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.form.receptType === 5
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key:
                                                    "userList-" +
                                                    _vm.form.receptType,
                                                  attrs: {
                                                    rules: [
                                                      {
                                                        required: true,
                                                        message: _vm.$t(
                                                          "home.pleaseSelectUser"
                                                        ),
                                                        trigger: "change",
                                                      },
                                                    ],
                                                    prop: "userList",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "320px",
                                                      },
                                                      attrs: {
                                                        loading:
                                                          _vm.userLoading,
                                                        placeholder: _vm.$t(
                                                          "home.selectUserAccount"
                                                        ),
                                                        "remote-method":
                                                          _vm.remoteSearchUser,
                                                        clearable: "",
                                                        "collapse-tags": "",
                                                        filterable: "",
                                                        multiple: "",
                                                        remote: "",
                                                        "reserve-keyword": "",
                                                      },
                                                      on: {
                                                        change: function (val) {
                                                          return _vm.handleSelectChange(
                                                            "userList",
                                                            val,
                                                            20
                                                          )
                                                        },
                                                        clear:
                                                          _vm.handleClearUser,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.userList,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "userList",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.userList",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.userOptions,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.id,
                                                          attrs: {
                                                            label:
                                                              item.username,
                                                            value: item.id,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-card",
            { staticClass: "panel", attrs: { shadow: "never" } },
            [
              _c("template", { slot: "header" }, [
                _c("h2", { staticClass: "panel-title" }, [
                  _vm._v(_vm._s(_vm.$t("home.publishTimeSection"))),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.publishMethod"),
                            prop: "publicatFormat",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.form.publicatFormat,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "publicatFormat", $$v)
                                },
                                expression: "form.publicatFormat",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.publishImmediately"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.scheduledPublish"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.isTop"),
                            prop: "topType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.form.topType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "topType", $$v)
                                },
                                expression: "form.topType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: _vm.$t("home.top"), value: 1 },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("home.notTop"),
                                  value: 0,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.publicatFormat === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("home.effectiveTime"),
                                prop: "effectiveTime",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "picker-options":
                                    _vm.effectiveTimePickerOptions,
                                  placeholder: _vm.$t(
                                    "home.selectEffectiveTime"
                                  ),
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.form.effectiveTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "effectiveTime", $$v)
                                  },
                                  expression: "form.effectiveTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.publicatFormat === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("home.expirationTime"),
                                prop: "failureTime",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "home.selectExpirationTime"
                                  ),
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.form.failureTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "failureTime", $$v)
                                  },
                                  expression: "form.failureTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm.viewMode !== "view"
        ? _c(
            "div",
            { staticClass: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("trajectory.Cancel"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.uploadLoading || _vm.draftLoading },
                  on: { click: _vm.handleSaveDraft },
                },
                [_vm._v(_vm._s(_vm.$t("home.saveDraft")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.uploadLoading || _vm.submitLoading,
                    type: "primary",
                  },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v(" " + _vm._s(_vm.$t("home.submitPublish")) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }